






























import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';

const Props = Vue.extend({
	props: {
		color: {
			type: String,
			default: '#a4c242'
		},
		icon: {
			type: String,
			default: 'helpon'
		},
		iconHover: {
			type: String,
			default: 'helpoff'
		},
		iconSize: {
			type: String,
			default: '24px'
		}
	}
});

@Component
export default class Tooltip extends Props {
}
